import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id 74A6BF3E-CEC2-40C3-A900-109D5E05E218
 * name triangle-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/triangle-outline.svg
 * tags
 * - Shape 
 */
export const TriangleOutlineIcon = createSvgIcon(<><path d="M12,2L1,21H23M12,6L19.53,19H4.47" /></>, 'TriangleOutlineIcon');
export default TriangleOutlineIcon